<template>
  <div class="page_content module_page explore_entity_result career_result" v-if="permission && permission.version === '5'" aria-label="explore career results">

    <div class="row page-heading">
          <div class="col-xl-8 col-lg-8 col-md-8 col-sm-11 col-xs-11 input module_heading" role="heading" aria-level="1">
            <span class="module_icon ico-career"></span>
            <h1 class="head_txt module_type_name ace_sec_hd" style="cursor: default;">Exploring {{total}} Careers</h1>
          </div>

          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-1 col-xs-1 btn_container">
            <!--
            <b-dropdown :animation="animation" variant="link" no-caret class="create-section-menu">
                <template slot="button-content">
                  <span class="icon-menu3x3"></span>
                </template>
            </b-dropdown>
            <b-btn class="btn btn-primary">Request Info</b-btn>
            <b-btn class="btn btn-primary">Apply Now</b-btn>
            <div v-if="!isClearlyNextPackageEnabled" style="float: right;">
                <b-link class="btn" v-if="isExplorePackageEnabled" :to="{ name: 'exploreIntro' }" aria-label="Explore" tabindex="0">explore</b-link>
            </div>
            -->

            <div class="data_souce_info">
              <div id="dataSouceInfo">
                <span class="ic ic8-info5"></span>
              </div>
              <b-popover target="dataSouceInfo" container="dataSouceInfoPopup" triggers="hover" style="margin-top: 20px;">
                <div class="popup_content">
                  {{careerDataSource}}
                </div>
              </b-popover>
              <div id="dataSouceInfoPopup"></div>
            </div>
            <!-- ==== data_souce_info ==== -->

          </div>
      </div>

      <div class="page_subheading">
        <div class="row select_flds_container">

          <!-- Search Bar -->
          <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-xs-12">
              <div class="row data-row">
                <div v-if="isCareerInterestEnabled" id="categoryDropDownPopup" class="dropdown_popover explore_filter_container"></div>
                <b-button v-if="isCareerInterestEnabled" @click="openCategoryDropDown" id="categoryDropDown" class="form-field career-interest ace_sec" tabindex="0">
                    <label for="state">
                      <span class="txt_sh">Select </span>{{careerInterestLabel}}
                      <span class="icon-dropdown1"></span>
                    </label>
                    <!-- <v-select class="select-field" v-model='minor' :options='minors' placeholder="Select or type in Minor(s)"></v-select> -->
                </b-button>
                <b-popover
                  v-if="isCareerInterestEnabled"
                  target="categoryDropDown"
                  :show.sync="showCategoryDropDown"
                  container="categoryDropDownPopup"
                  custom-class="sort_by_modal"
                  triggers="blur">
                  <!--
                    <div class="header-content-row" style="background: #d0eaf5;">
                      <span class="title">Select {{careerInterestLabel}}</span>
                      <button class="btn_close" aria-label="close" @click="closeCategoryDropDown">
                        <span class="ic-close"></span>
                      </button>
                    </div>
                  -->
                    <div class="popup_content">
                      <input type="text" class="input-search ml-1 mt-2 mb-2" :aria-label="'Type To Filter ' + careerInterestLabel" :placeholder="'Type To Filter ' + careerInterestLabel" style="width: 93%;" v-model.trim="careerCategorySearch">
                      <!--
                      <template v-if="careerCategories.length > 0">
                        <virtual-list
                          class="facet-item-list"
                          :data-key="'key'"
                          :data-sources="careerCategories"
                          :data-component="careerCategoryItemComponent"
                          :extra-props="{parent: parentComponent}"
                        />
                      </template>
                      -->
                      <template v-for="(careerCategory, index) in careerCategories">
                        <div class="field-row">
                          <input :id="'careerCategoryCheck_' + index" type="checkbox" :aria-labelledby="'careerCategoryK_' + index" :checked="careerCategory.isSelected" @input.stop="filterSelected(careerCategory, 'careerCategory')"></input>
                          <label :for="'careerCategoryCheck_' + index" :id="'careerCategoryK_' + index">{{careerCategory.key}}<span v-if="showFacetCounts">[{{careerCategory.doc_count}}]</span></label>
                        </div>
                      </template>
                    </div>
                    <b-btn @click="closeCategoryDropDown" class="range-button">ok</b-btn>
                </b-popover>

                <div v-if="isIncomeRangeEnabled" id="incomeRangeDropDownPopup" class="dropdown_popover explore_filter_container popup_income_range"></div>
                <b-button v-if="isIncomeRangeEnabled" @click="openIncomeRangeDropDown" id="incomeRangeDropDown" class="form-field income-range ace_sec" tabindex="0">
                  <label>
                    <span class="txt_sh">Select </span>{{incomeRangeLabel}}
                    <span class="icon-dropdown1"></span>
                  </label>
                  <!-- <v-select class="select-field" v-model='industry' :options='industries' placeholder="Select or type in Job"></v-select> -->
                </b-button>
                <b-popover v-if="isIncomeRangeEnabled" target="incomeRangeDropDown" :show.sync="showIncomeRangeDropDown" container="incomeRangeDropDownPopup" triggers="blur">
                    <!--
                    <div class="header-content-row income">
                      <span class="title">{{incomeRangeLabel}}</span>
                      <button class="btn_close" aria-label="close" @click="closeIncomeRangeDropDown">
                        <span class="ic-close"></span>
                      </button>
                    </div>
                    -->
                    <template v-for="(range, index) in formattedFacetResults.careerIncomeRange" >
                      <div class="field-row">
                        <input type="radio" :id="'careerIncomeRange_' + index" :checked="range.isSelected" @input.stop="filterSelected(range, 'careerIncomeRange')">
                        <label :for="'careerIncomeRange_' + index">{{range.label}} <span v-if="showFacetCounts">[{{range.doc_count}}]</span></label>
                      </div>
                    </template>

                    <div class="sec_sep"></div>

                    <b-input-group class="input_grp">
                      <div class="range-group">
                        <span class="input-title">min</span>
                        <b-form-input id="customIncomeMin" v-model="customIncomeMin" aria-label="minimum income" number="true" type="number" min="0"></b-form-input>
                      </div>

                      <div class="range-group">
                        <span class="input-title">max</span>
                        <b-form-input id="customIncomeMax" v-model="customIncomeMax" aria-label="maximum income" number="true" type="number" min="0"></b-form-input>
                      </div>
                  </b-input-group>
                    <b-btn @click="customRangeSelected" class="range-button">ok</b-btn>
                </b-popover>
          </div>
        </div>

          <!-- Page Buttons -->
          <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-xs-12 text-right">

            <div class="search-box-container">
              <!--<span class="icon-filter" v-b-modal.filtering></span>-->
              <input v-if="isSearchBarEnabled" type="text" class="input-search" placeholder="search for careers" v-on:keypress.enter="searchButtonClicked" v-model.trim="searchTerms" aria-label="search for careers">
              <button v-if="isSearchBarEnabled" class="btn btn_srh" @click="searchButtonClicked" aria-label="go">
                <span v-if="isSearchBarEnabled" class="ic_srh ic_search"></span>
                <!--
                <span class="txt_srh">search</span>
                -->
              </button>
              <button v-if="isSortByEnabled" id="sortByDropDown" type="button" @click="openSortByDropDown" class="sort-by ace_sec">
                <span class="ic2_sort2 sort-by-icon"></span>
                <!-- span class="txt_srt">filter / sort</span -->
                <span class="txt_srt">sort</span>
              </button>
              <div id="careerListSortPopup" class="sort_by_popover"></div>
            </div>
            <b-popover target="sortByDropDown" :show.sync='showSortByDropDown' container="careerListSortPopup" triggers="blur">
              <div class='header-content-row'>
                <span class="title">Filter</span>
              </div>
              <div class="filter_row_container">
                <div v-if="isInstitutionCareersEnabled && !showInstitutionCareerFilter" @click="institutionCareerFilterSelected">
                  <div class="field-row">
                    <div class="form-check">
                      <span class="ic9-checkbox-unchecked"></span>
                      <label class="form-check-label row_txt">{{institutionCareersLabel}}</label>
                    </div>
                  </div>
                </div>
                <div v-else @click="clearInstitutionCareerFilter">
                  <div class="field-row">
                    <div class="form-check">
                      <span class="ic9-checkbox-checked"></span>
                      <label class="form-check-label row_txt">{{institutionCareersLabel}}</label>
                    </div>
                  </div>
                </div>
                <div v-if="isCareerRecommendationEnabled && !showRecommedation" @click="recommendedCareerFilterSelected">
                  <div class="field-row">
                    <div class="form-check">
                      <span class="ic9-checkbox-unchecked"></span>
                      <label class="form-check-label row_txt">{{careerRecommendationLabel}}</label>
                    </div>
                  </div>
                </div>
                <div v-if="isCareerRecommendationEnabled && showRecommedation"  @click="clearRecommendedCareerFilterSelected">
                  <div class="field-row">
                    <div class="form-check">
                      <span class="ic9-checkbox-checked"></span>
                      <label class="form-check-label row_txt">{{careerRecommendationLabel}}</label>
                    </div>
                  </div>
                </div>

              </div>
              <div class='header-content-row'>
                <span class="title">Sort by</span>
                <!--
                <button class="btn_close" aria-label="close" @click="closeSortByDropDown">
                  <span class="ic-close"></span>
                </button>
                -->
              </div>
              <template v-for="sort in sortByOptions">
                <div class="field-row">
                  <div class="form-check">
                    <input type="radio" class="form-check-input" :id="sort.name" :checked="selectedSort" v-model="selectedSort" v-bind:value="sort.clause">
                    <label class="form-check-label" :for="sort.name">{{ sort.name }}</label>
                  </div>
                </div>
              </template>

              <b-btn @click="closeSortByDropDown" class="range-button">ok</b-btn>

            </b-popover>

                <!-- <button type="button" :disabled="this.firstPage" @click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
                <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
                  <option v-for="option in sizeOptions" v-bind:value="option">
                      {{ option }}
                  </option>
                </select>
                <button type="button" :disabled="this.lastPage" @click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>-->

          </div>
        </div>

        <div class="list-view-section">
            <b-input-group>

                  <template v-for="category in formattedFacetResults.careerCategory">
                      <div v-if="category.isSelected" class="search_tag">
                        <span class="title category">{{category.key}}</span>
                      <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="filterSelected(category, 'careerCategory', true)">
                      </span>
                     </div>
                  </template>
                  <template v-for="range in formattedFacetResults.careerIncomeRange">
                      <div v-if="range.isSelected" class="search_tag">
                         <span class="title income_range">{{range.label}}</span>
                       <span  class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter">
                       </span>
                    </div>
                  </template>
                  <div v-if="careerSearchCustomIncomeMax && careerSearchCustomIncomeMin" class="search_tag">
                    <span class="title income_range">${{careerSearchCustomIncomeMin}} - ${{careerSearchCustomIncomeMax}}</span>
                    <span  class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter"></span>
                  </div>
                  <div v-if="careerSearchCustomIncomeMax && !careerSearchCustomIncomeMin" class="search_tag">
                    <span class="title income_range"> < ${{careerSearchCustomIncomeMax}}</span>
                    <span  class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter"></span>
                  </div>
                  <div v-if="!careerSearchCustomIncomeMax && careerSearchCustomIncomeMin" class="search_tag">
                    <span class="title income_range"> > ${{careerSearchCustomIncomeMin}}</span>
                    <span  class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter"></span>
                  </div>
                  <div v-if="showInstitutionCareerFilter && isInstitutionCareersEnabled" class="search_tag">
                    <span class="title income_range"> {{institutionCareersLabel}}</span>
                    <span  class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="clearInstitutionCareerFilter"></span>
                  </div>
                  <div v-if="showRecommedation && isCareerRecommendationEnabled" class="search_tag">
                    <span class="title income_range"> {{careerRecommendationLabel}}</span>
                    <span  class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="clearRecommendedCareerFilterSelected"></span>
                  </div>

              </b-input-group>
          </div>

    </div> <!-- .page_subheading -->

    <div class="page_content_container" style="overflow-y: hidden !important;">

      <template v-if="formattedResults.length > 0">
        <virtual-list
          class="item-list"
          :data-key="'uuid'"
          :data-sources="formattedResults"
          :data-component="itemComponent"
          :estimate-size="60"
          :extra-props="{parent: parentComponent}"
          :item-style="{'border-bottom': '1px solid #e6e6e6'}"
        />
      </template>

      <div class="list_container">
        <template v-if="isResultsLoaded && formattedResults.length == 0">
          <div class="data_tbl_container">
            <div class="no_result">No result found</div>
          </div>
        </template>

        <template v-if="showSkillProgressPopup">
          <explore-career-skill-progress
            :title="selectedCareer.name"
            :stream-id="planningStream.uuid"
            :career-id="selectedCareer.uuid"
            :skill-progress-target-id="skillProgressTargetId">
          </explore-career-skill-progress>
        </template>

        </div>
      </div>

    <div class="loading-spinner">
        <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
            <div class="text-center" style="color: #FFF">
              <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
            </div>
        </b-modal>
      </div>

  </div>
</template>

<script>
import '../../../assets/module/sass/explore/explore.scss'
import '../../../assets/module/css/user/userList.min.css'
import '../../../assets/module/css/institution/institutionEntities.min.css'
import ExploreCareerSkillProgress from './ExploreCareerSkillProgress'
import { mapActions, mapState } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import _ from 'lodash'
import CareerItem from './CareerItem'
import CareerCategoryItem from './CareerCategoryItem'
import VirtualList from 'vue-virtual-scroll-list'

export default {
  name: 'explore-career-results',
  components: {
    ExploreCareerSkillProgress,
    VirtualList
  },
  data () {
    return {
      itemComponent: CareerItem,
      careerCategoryItemComponent: CareerCategoryItem,
      careerCategorySearch: '',
      size: 500, // NOTE: ElasticSearch needs size parameter set or defaults to 10
      isResultsLoaded: false,
      showRecommedation: false,
      userId: localStorage.getItem('userid'),
      permission: {},
      searchTerms: '',
      source: [
        'uuid',
        'name',
        'description',
        'category',
        'medianIncomePerYear',
        'growth',
        'openings',
        'openingsDoubleFormat',
        'currentEmployment',
        'code',
        'pragyaSoc',
        'thumbnailURI',
        'source', // EMSI or O-NET,
        'jobTitles',
        '_score'
      ],
      sorts: [
        {name: 'Relevance', clause: [{_score: {order: 'desc'}}]},
        {name: 'Title', clause: [{'name.raw': {order: 'asc'}}]},
        {name: 'Median Income', clause: [{medianIncomePerYear: {order: 'desc'}}]},
        // {name: 'Growth Rate', clause: [{growth: {order: 'desc'}}]}, // NOTE: not populated for all data
        {name: 'Job Postings', clause: [{'openingsDoubleFormat': {order: 'desc'}}]}
      ],
      selectedSort: {},
      selectedFacetNames: [],
      facetFieldMap: {
        careerCategory: 'category.raw',
        careerIncomeRange: 'medianIncomePerYear'
      },
      filter: {},
      showCategoryDropDown: false,
      showIncomeRangeDropDown: false,
      showSortByDropDown: false,
      customIncomeMin: '',
      customIncomeMax: '',
      navigationErrorMessage: 'No SOC data found for this Career. Please re-upload to see more details',
      SOURCE_EMSI: 'emsi',
      SOURCE_CAREER_ONE_STOP: 'cos',
      SOURCE_BGT: 'bgt',
      SOURCE_LIGHTCAST: 'lightcast',
      skillProgressTargetId: '',
      showSkillProgressPopup: false,
      titlePopoverEnabled: false,
      showInstitutionCareerFilter: ''
    }
  },

  created () {
    // this.showLoader()
  },

  async mounted () {
    this.showLoader()
    this.initializeSearchData()
    this.permission = await this.loadPermission()
    await this.loadInstitutionDetail()
    await this.loadInstitutionPackage({isAggregated: false})
    await this.loadAllBookmarks()
    await this.loadInstitutionCareers()
    await this.loadRecommendedCareers()
    this.showRecommedation = (this.isCareerRecommendationEnabledFeature() && this.recommendedCareers && this.recommendedCareers.length > 0)
    this.loadCareerResults()
  },

  methods: {
    ...mapActions([
      'loadPermission',
      'searchForCareers',
      'loadLibrariesForUser',
      'loadInstitutionDetail',
      'loadInstitutionPackage',
      'loadAllBookmarks',
      'loadCreateBookmarks',
      'loadDeleteBookmark',
      'saveCareerSearchState',
      'loadPlanningStream',
      'loadLogDashboardActivity',
      'loadCareerScrollLeft',
      'loadCareerScrollTop',
      'loadInstitutionCareers',
      'loadRecommendedCareers'
    ]),

    showLoader () {
      this.$parent.$refs.loadingModal.show()
    },

    hideLoader () {
      this.$parent.$refs.loadingModal.hide()
    },

    searchButtonClicked () {
      let searchTerms = this.searchTerms
      if (searchTerms && searchTerms.length > 0) {
        this.selectedSort = this.relevanceSort
      } else {
        this.selectedSort = this.nameSort
      }
      return this.loadCareerResults()
    },

    loadCareerResults () {
      this.saveCareerSearchState({
        terms: this.searchTerms,
        sort: { clause: this.selectedSort },
        filter: this.filter,
        selectedFacetNames: this.selectedFacetNames,
        customIncomeMin: this.customIncomeMin,
        customIncomeMax: this.customIncomeMax,
        institutionCareerFilter: this.showInstitutionCareerFilter
      })
      this.isResultsLoaded = false
      let loadSearchResults = this.searchForCareers
      let filter = this.buildFilter()
      let facets = this.buildFacets()
      let isFacetResultsEmpty = this.isFacetResultsEmpty
      const searchInput = {
        terms: this.searchTerms,
        sort: this.selectedSort,
        source: this.source,
        from: 0,
        size: this.size,
        userId: this.userId,
        facets: facets,
        filter: filter,
        facetNames: this.allFacetNames,
        selectedFacetNames: this.selectedFacetNames // NOTE: uncomment for dynamic faceting
        // selectedFacetNames: isFacetResultsEmpty ? this.selectedFacetNames : this.allFacetNames // NOTE: uncomment for "sticky" faceting
      }
      if (this.isStickyFacetsEnabled) {
        searchInput.selectedFacetNames = isFacetResultsEmpty ? this.selectedFacetNames : this.allFacetNames
      }
      loadSearchResults(searchInput).then(res => {
        setTimeout(() => {
          this.isResultsLoaded = true
          this.hideLoader()
          this.loadPlanningStream()
          $('.item-list').animate({
            scrollTop: this.careerScrollTop
          }, 0)
        }, 0)
      })
    },

    checkTitleLength (rowNo) {
      let titleContainerHeight = $('#entityName_' + rowNo).innerHeight()
      if (titleContainerHeight > 59) {
        this.titlePopoverEnabled = true
      } else {
        this.titlePopoverEnabled = false
      }
    },

    goToCareerDetail (career) {
      this.loadCareerScrollLeft($('.item-list').scrollLeft())
      this.loadCareerScrollTop($('.item-list').scrollTop())
      if (!career.code) {
        return this.notifyFailure(this.navigationErrorMessage)
      }
      let routerParams = {
        code: career.pragyaSoc,
        returnTo: 'exploreCareerResults',
        showBackToResultButton: true
      }
      this.loadLogDashboardActivity({action: 'clickExploreCareerResult', page: 'exploreCareers', link: '', careerSocCode: career.code})
      return this.$router.push({ name: 'careerDetail', params: routerParams, query: {returnTo: 'exploreCareerResults'} })
    },

    setImageWidth (imageId) {
      let getImageWidth = $('#img_' + imageId).width()
      let getImageHeight = $('#img_' + imageId).height()
      if (getImageWidth > getImageHeight) {
        return ''
      } else {
        return 'img_w_100'
      }
    },

    getCareerBookmark (career) {
      let bookmarks = this.bookmarks
      if (!bookmarks || !bookmarks.length) {
        return false
      }
      let target = false
      bookmarks.forEach(bookmark => {
        if (bookmark.entityUuid === career.uuid) {
          target = bookmark
        }
      })
      return target
    },

    openCategoryDropDown () {
      this.loadLogDashboardActivity({action: 'clickExploreCareerCategory', page: 'exploreCareers', link: ''})
      this.showCategoryDropDown = !this.showCategoryDropDown
    },

    closeCategoryDropDown () {
      this.showCategoryDropDown = false
    },

    openIncomeRangeDropDown () {
      this.loadLogDashboardActivity({action: 'clickExploreCareerIncome', page: 'exploreCareers', link: ''})
      this.showIncomeRangeDropDown = !this.showIncomeRangeDropDown
    },

    closeIncomeRangeDropDown () {
      this.showIncomeRangeDropDown = false
    },

    openSortByDropDown () {
      this.loadLogDashboardActivity({action: 'clickExploreCareerSortBy', page: 'exploreCareers', link: ''})
      this.showSortByDropDown = !this.showSortByDropDown
    },

    closeSortByDropDown () {
      this.showSortByDropDown = false
    },

    institutionCareerFilterSelected () {
      this.showInstitutionCareerFilter = true
      return this.loadCareerResults()
    },
    recommendedCareerFilterSelected () {
      this.showRecommedation = true
      return this.loadCareerResults()
    },

    clearRecommendedCareerFilterSelected () {
      this.showRecommedation = false
      return this.loadCareerResults()
    },

    clearInstitutionCareerFilter () {
      this.showInstitutionCareerFilter = false
      return this.loadCareerResults()
    },

    isTermFilterSelected (facet, fieldName) {
      let valuesToFilter = this.filter[fieldName]
      let fieldValue = facet.key
      return valuesToFilter && valuesToFilter.includes(fieldValue)
    },

    isCustomRangeFilterActive () {
      const medianIncomePerYear = this.facetFieldMap.careerIncomeRange
      let selectedRangeFilter = this.filter[medianIncomePerYear]
      return selectedRangeFilter && selectedRangeFilter.isCustom
    },

    isRangeFilterSelected (rangeFacet, fieldName) {
      let selectedRangeFilter = this.filter[fieldName].rangeInterval
      return selectedRangeFilter && selectedRangeFilter === rangeFacet.rangeInterval
    },

    isFilterSelected (facet, fieldName) {
      return this.isTermFilterSelected(facet, fieldName) || this.isRangeFilterSelected(facet, fieldName)
    },

    filterSelected (facet, facetName, deleted) {
      const fieldName = this.facetFieldMap[facetName]
      const fieldValue = facet.key || facet.rangeInterval
      const isRangeFacet = fieldName === this.facetFieldMap.careerIncomeRange
      if (isRangeFacet) {
        // NOTE only allow one range filter at a time
        this.filter[fieldName] = {
          from: facet.from,
          to: facet.to,
          rangeInterval: facet.rangeInterval,
          isCustom: facet.isCustom === true
        }
        if (!facet.isCustom) {
          this.customIncomeMin = ''
          this.customIncomeMax = ''
          this.$forceUpdate()
        }
        if (!this.selectedFacetNames.includes(facetName)) {
          this.selectedFacetNames.push(facetName)
        }
      } else if (this.isTermFilterSelected(facet, fieldName)) {
        this.filter[fieldName] = this.filter[fieldName].filter(v => v !== fieldValue)

        // remove the facetName from selected list if no other value in that category is selected
        // ex) facetName = 'department', this.filter.department = ['CSCI'] ==> selectedFacetNames = ['department']
        // ex2) facetName = 'department', this.filter.department = [] ==> selectedFacetNames = []
        const isFacetSelected = this.selectedFacetNames.includes(facetName)
        const isFacetUnused = this.filter[fieldName].length === 0
        if (isFacetSelected && isFacetUnused) {
          this.selectedFacetNames = this.selectedFacetNames.filter(v => v !== facetName)
        }
      } else {
        this.filter[fieldName].push(fieldValue)
        if (!this.selectedFacetNames.includes(facetName)) {
          this.selectedFacetNames.push(facetName)
        }
      }
      // if not selected, add the value to the filter and selectedFacetNames list
      this.loadCareerResults()
      if (deleted) {
        this.careerCategorySearch = ''
      }
    },

    buildTermClause (fieldName, filterValues) {
      let clause = {
        'terms': {}
      }
      clause.terms[fieldName] = filterValues
      return clause
    },

    buildRangeClause (fieldName, from, to) {
      let clause = {'range': {}}
      clause.range[fieldName] = {}
      if (from) {
        clause.range[fieldName]['gte'] = from
      }
      if (to) {
        clause.range[fieldName]['lt'] = to
      }
      return clause
    },

    initializeSearchData () {
      console.log('got called')
      this.showInstitutionCareerFilter = this.careerSearchInstitutionCareerFilter
      this.searchTerms = this.careerSearchTerms || ''
      this.selectedFacetNames = this.careerSearchSelectedFacetNames || []
      this.customIncomeMin = this.careerSearchCustomIncomeMin || ''
      this.customIncomeMax = this.careerSearchCustomIncomeMax || ''
      if (this.careerSearchTerms) {
        this.selectedSort = this.relevanceSort // Always default to nameSort initially
      } else {
        this.selectedSort = this.nameSort
      }
      let filter = this.careerSearchFilter
      if (this.isFilterEmpty(filter)) {
        Object.values(this.facetFieldMap).forEach(fieldName => {
          filter[fieldName] = []
        })
      }
      this.filter = filter
    },

    isFilterEmpty (filter) {
      let isEmpty = true
      filter = filter || this.filter
      Object.values(filter).forEach(filterValues => {
        isEmpty = isEmpty && !filterValues
      })
      return isEmpty
    },

    buildFilter () {
      let elasticSearchFilter = {
        'bool': {
          'must': []
        }
      }
      let filter = this.filter
      let buildTermClause = this.buildTermClause
      let buildRangeClause = this.buildRangeClause
      let medianIncomePerYear = this.facetFieldMap.careerIncomeRange
      Object.keys(filter).forEach(fieldName => {
        const isTermFacet = fieldName !== medianIncomePerYear
        const isRangeFacet = !isTermFacet
        let filterValues = filter[fieldName]
        if (isTermFacet && filterValues && filterValues.length > 0) {
          elasticSearchFilter.bool.must.push(buildTermClause(fieldName, filterValues))
        } else if (isRangeFacet && filterValues.rangeInterval) {
          elasticSearchFilter.bool.must.push(buildRangeClause(fieldName, filterValues.from, filterValues.to))
        }
      })
      // filter field 'source' => 'ONET' or 'EMSI'
      elasticSearchFilter.bool.must.push(this.laborSourceFilter)
      // check if institution filter package feature is on and if institution careers exist
      if (this.showInstitutionCareerFilter && this.institutionCareers.length > 0 && this.isInstitutionCareersEnabled) {
        let institutionCareerFilter = {
          'terms': {
            'code.raw': this.institutionCareers
          }
        }
        elasticSearchFilter.bool.must.push(institutionCareerFilter)
      }
      if (this.isCareerRecommendationEnabledFeature() && this.showRecommedation && this.recommendedCareers && this.recommendedCareers.length > 0 ) {
        let recommendaedCareersFilter = {
          'terms': {
            'pragyaSoc.raw': this.recommendedCareers
          }
        }
        elasticSearchFilter.bool.must.push(recommendaedCareersFilter)
      }

      return elasticSearchFilter
    },

    getFacetFilter (facetName) {
      let facetFilter = {
        'bool': {
          'must': []
        }
      }
      const isFilterEmpty = this.isFilterEmpty()
      if (!isFilterEmpty && !this.selectedFacetNames.includes(facetName)) {
        let buildFilter = this.buildFilter()
        facetFilter.bool.must = facetFilter.bool.must.concat(buildFilter.bool.must)
      }
      return facetFilter
    },

    buildFacet (field, order, facetName) {
      return {
        'aggs': {
          'termObj': {
            'terms': {
              'field': field,
              'order': order,
              'size': 1000
            }
          }
        },
        'filter': this.getFacetFilter(facetName)
      }
    },

    closeAllDropDowns () {
      this.closeCategoryDropDown()
      this.closeIncomeRangeDropDown()
      this.closeSortByDropDown()
    },

    customRangeSelected () {
      // ignore ranges where either inputs are empty to avoid confusing UX.
      this.validateCustomRanges()
      if (!this.customIncomeMin && !this.customIncomeMax) {
        return this.isCustomRangeFilterActive() ? this.clearRangeFilter() : this.closeIncomeRangeDropDown()
      }
      let range = {from: this.customIncomeMin, to: this.customIncomeMax}
      range.rangeInterval = range.from + '-' + range.to
      if (!range.from) {
        range.rangeInterval = '< ' + range.to
      } else if (!range.to) {
        range.rangeInterval = '> ' + range.from
      }
      range.isCustom = true
      this.closeIncomeRangeDropDown()
      this.filterSelected(range, 'careerIncomeRange')
    },

    clearRangeFilter () {
      const careerIncomeRange = 'careerIncomeRange'
      const medianIncomePerYear = this.facetFieldMap[careerIncomeRange]
      this.customIncomeMin = ''
      this.customIncomeMax = ''
      this.filter[medianIncomePerYear] = {}
      this.selectedFacetNames = this.selectedFacetNames.filter(v => v !== careerIncomeRange)
      this.closeIncomeRangeDropDown()
      this.loadCareerResults()
    },

    notifySuccess (text) {
      return this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },

    notifyFailure (text) {
      return this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },

    addCommaInNumber (numValue) {
      let numValueRound = Math.round(numValue)
      let numValueFormat = numValueRound.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return numValueFormat
    },

    updateTitleHeight (index) {
      let titleContainerHeight = $('#entityName_' + index).height()
      if (titleContainerHeight > 30) {
        $('#entityDesc_' + index).addClass('srt_desc')
      }
    },

    showMoreDescLnk (entityDescRowId) {
      let descContainerHeight = $('#entityDesc_' + entityDescRowId + ' .desc_txt').height()
      if (descContainerHeight > 65) {
        return 'show_more_link'
      } else {
        return 'hide_more_link'
      }
    },

    async bookmarkCareer (career) {
      const bookmark = {
        'source': 'explore',
        'entityType': 'career',
        'entityTitle': career.name,
        'entityUuid': career.uuid,
        // 'institutionId': career.institutionId,
        'userId': this.userId
      }
      const response = await this.loadCreateBookmarks(bookmark)
      const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + career.name + '\''
      const notify = response ? this.notifySuccess : this.notifyFailure
      notify(message)
      await this.loadAllBookmarks() // Refresh Vuex state to mark Career as bookmarked
    },

    async deleteCareerBookmark (career) {
      await this.loadDeleteBookmark(career.bookmark.uuid)
      this.notifySuccess('Successfully deleted bookmark \'' + career.name + '\'')
      await this.loadAllBookmarks() // Refresh Vuex state to mark Career as bookmarked
    },

    isBookmarked (career) {
      return career.bookmark && career.bookmark.uuid
    },

    validateCustomRanges () {
      let customIncomeMin = this.customIncomeMin
      let customIncomeMax = this.customIncomeMax
      if (isNaN(customIncomeMin) || isNaN(customIncomeMax) || customIncomeMin < 0 || customIncomeMax < 0) {
        customIncomeMin = ''
        customIncomeMax = ''
      }
      this.customIncomeMin = customIncomeMin
      this.customIncomeMax = customIncomeMax
      this.$forceUpdate()
    },

    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },

    buildFacets () {
      const termOrder = {'_key': 'asc'}
      let buildFacet = this.buildFacet
      let getFacetFilter = this.getFacetFilter
      let facets = {
        'careerCategory': buildFacet('category.raw', termOrder, 'careerCategory'),
        'careerIncomeRange': {
          'aggs': {
            'rangeObj': {
              'range': {
                'field': 'medianIncomePerYear',
                'ranges': [
                  {'to': 25000},
                  {'from': 25000, 'to': 50000},
                  {'from': 50000, 'to': 75000},
                  {'from': 75000}
                ]
              }
            }
          },
          'filter': getFacetFilter('careerIncomeRange')
        }
      }
      return facets
    },

    calculateSkillProgressClicked (career, event) {
      this.selectedCareer = career
      this.skillProgressTargetId = event.target.id
      this.showSkillProgressPopup = true
    },
    isCareerRecommendationEnabledFeature () {
      if((localStorage.getItem('userrole') !== 'Student')){
        return false
      }
      let careerRecommendationFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CAREER_RECOMMENDATION]
      if (careerRecommendationFeature) {
        return careerRecommendationFeature.enabled
      }
      return false
    },

    getThumbnailURI (document) {
      if (document.thumbnailURI) {
        return document.thumbnailURI
      }
      return 'https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/soc-' + document.code + '---00.svg'
    }
  },
  computed: {
    ...mapState({
      'permission': state => state.user.permission,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'packages': state => state.institution.packages,
      'institution': state => state.institution.institution,
      'careerFacetResults': state => state.explore.careerFacetResults,
      'careerSearchResults': state => state.explore.careerSearchResults,
      'bookmarks': state => state.explore.bookmarks,
      'careerSearchTerms': state => state.explore.careerSearchTerms,
      'careerSearchSort': state => state.explore.careerSearchSort,
      'careerSearchFilter': state => state.explore.careerSearchFilter,
      'careerSearchSelectedFacetNames': state => state.explore.careerSearchSelectedFacetNames,
      'careerSearchCustomIncomeMin': state => state.explore.careerSearchCustomIncomeMin,
      'careerSearchCustomIncomeMax': state => state.explore.careerSearchCustomIncomeMax,
      'planningStream': state => state.dashboard.planningStream,
      'total': state => state.explore.careerTotal,
      'careerScrollTop': state => state.explore.careerScrollTop,
      'careerScrollLeft': state => state.explore.careerScrollLeft,
      'institutionCareers': state => state.explore.institutionCareers,
      'recommendedCareers' : state =>state.explore.recommendedCareers,
      'careerSearchInstitutionCareerFilter': state => state.explore.careerSearchInstitutionCareerFilter

    }),
    careerDataSource () {
      if (this.isBGTFeatureEnabled) {
        return 'Source: Burning Glass. 2018-2028'
      }
      if (this.isLightcastFeatureEnabled) {
        return 'Source: Lightcast. 2023-2033'
      }
      return 'Source: BLS. 2016-2026'
    },
    isInstitutionCareersEnabled () {
      let institutionCareersFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.INSTITUTION_CAREERS]
      if (institutionCareersFeature) {
        return institutionCareersFeature.enabled
      }
      return false
    },
    institutionCareersLabel () {
      let institutionCareersFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.INSTITUTION_CAREERS]
      if (institutionCareersFeature && institutionCareersFeature.label) {
        return institutionCareersFeature.label
      }
      return 'only Institution Careers'
    },
    parentComponent () {
      return this
    },
    exploreCareersFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_CAREERS
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    careerRecommendationFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.CAREER_RECOMMENDATION
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },

    showDescriptionOnResult () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultDescription) {
        return false
      }
      return exploreCareersFlagMap.searchResultDescription.enabled
    },
    showMedianIncomeOnResult () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultMedianIncome) {
        return false
      }
      return exploreCareersFlagMap.searchResultMedianIncome.enabled
    },
    medianIncomeResultLabel () {
      const defaultLabel = 'median income'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultMedianIncome) {
        return defaultLabel
      }
      return exploreCareersFlagMap.searchResultMedianIncome.label || defaultLabel
    },
    showJobPostingsOnResult () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultJobPosting) {
        return false
      }
      return exploreCareersFlagMap.searchResultJobPosting.enabled
    },
    jobPostingsResultLabel () {
      const defaultLabel = 'job postings'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultJobPosting) {
        return defaultLabel
      }
      return exploreCareersFlagMap.searchResultJobPosting.label || defaultLabel
    },
    showGrowthRateOnResult () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultGrowthRate) {
        return false
      }
      return exploreCareersFlagMap.searchResultGrowthRate.enabled
    },
    growthRateResultLabel () {
      const defaultLabel = 'growth rate'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultGrowthRate) {
        return defaultLabel
      }
      return exploreCareersFlagMap.searchResultGrowthRate.label || defaultLabel
    },
    showBookmarkOnResult () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultBookMark) {
        return false
      }
      return exploreCareersFlagMap.searchResultBookMark.enabled
    },
    isSortByEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortBy) {
        return false
      }
      return exploreCareersFlagMap.sortBy.enabled
    },
    isSortByRelevanceEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByRelevance) {
        return false
      }
      return exploreCareersFlagMap.sortByRelevance.enabled
    },
    sortByRelevanceLabel () {
      const defaultLabel = 'Relevance'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByRelevance) {
        return defaultLabel
      }
      return exploreCareersFlagMap.sortByRelevance.label || defaultLabel
    },
    isSortByTitleEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByTitle) {
        return false
      }
      return exploreCareersFlagMap.sortByTitle.enabled
    },
    sortByTitleLabel () {
      const defaultLabel = 'Title'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByTitle) {
        return defaultLabel
      }
      return exploreCareersFlagMap.sortByTitle.label || defaultLabel
    },
    isSortByMedianIncomeEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByMedianIncome) {
        return false
      }
      return exploreCareersFlagMap.sortByMedianIncome.enabled
    },
    sortByMedianIncomeLabel () {
      const defaultLabel = 'Median Income'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByMedianIncome) {
        return defaultLabel
      }
      return exploreCareersFlagMap.sortByMedianIncome.label || defaultLabel
    },
    isSortByJobPostingEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByJobPosting) {
        return false
      }
      return exploreCareersFlagMap.sortByJobPosting.enabled
    },
    sortByJobPostingsLabel () {
      const defaultLabel = 'Job Postings'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByJobPosting) {
        return defaultLabel
      }
      return exploreCareersFlagMap.sortByJobPosting.label || defaultLabel
    },
    sortByOptions () {
      let options = []
      let sorts = this.sorts
      if (this.isSortByRelevanceEnabled) {
        sorts[0].name = this.sortByRelevanceLabel
        options.push(sorts[0])
      }
      if (this.isSortByTitleEnabled) {
        sorts[1].name = this.sortByTitleLabel
        options.push(sorts[1])
      }
      if (this.isSortByMedianIncomeEnabled) {
        sorts[2].name = this.sortByMedianIncomeLabel
        options.push(sorts[2])
      }
      if (this.isSortByJobPostingEnabled) {
        sorts[3].name = this.sortByJobPostingsLabel
        options.push(sorts[3])
      }
      return options
    },
    isSearchBarEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchCareers) {
        return false
      }
      return exploreCareersFlagMap.searchCareers.enabled
    },
    isCareerInterestEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.selectCareerInterest) {
        return false
      }
      return exploreCareersFlagMap.selectCareerInterest.enabled
    },
    isCareerRecommendationEnabled () {
      if((localStorage.getItem('userrole') !== 'Student')){
        return false
      }
      let careerRecommendationFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CAREER_RECOMMENDATION]
      if (careerRecommendationFeature) {
        return careerRecommendationFeature.enabled
      }
      return false
    },
    careerRecommendationLabel () {
      const defaultLabel = 'Recommendations for me'
      let careerRecommendationFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CAREER_RECOMMENDATION]
      if (careerRecommendationFeature) {
          return careerRecommendationFeature.label || defaultLabel
      }
      return defaultLabel
    },

    careerInterestLabel () {
      const defaultLabel = 'Career Interest'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.selectCareerInterest) {
        return defaultLabel
      }
      return exploreCareersFlagMap.selectCareerInterest.label || defaultLabel
    },
    isIncomeRangeEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.selectIncomeRange) {
        return false
      }
      return exploreCareersFlagMap.selectIncomeRange.enabled
    },
    incomeRangeLabel () {
      const defaultLabel = 'Income Range'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.selectIncomeRange) {
        return defaultLabel
      }
      return exploreCareersFlagMap.selectIncomeRange.label || defaultLabel
    },
    laborSourceFilter () {
      if (this.isEMSIFeatureEnabled) {
        return this.buildTermClause('source', [this.SOURCE_EMSI])
      }
      if (this.isBGTFeatureEnabled) {
        return this.buildTermClause('source', [this.SOURCE_BGT])
      }
      if (this.isLightcastFeatureEnabled) {
        return this.buildTermClause('source', [this.SOURCE_LIGHTCAST])
      }
      return this.buildTermClause('source', [this.SOURCE_CAREER_ONE_STOP])
    },
    isEMSIFeatureEnabled () {
      let emsiFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_EMSI_SOURCE]
      return emsiFeature && emsiFeature.enabled
    },
    isBGTFeatureEnabled () {
      let bgtFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_BGT_SOURCE]
      return bgtFeature && bgtFeature.enabled
    },
    isLightcastFeatureEnabled () {
      let lightcastFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_LIGHTCAST_SOURCE]
      return lightcastFeature && lightcastFeature.enabled
    },
    isClearlyNextPackageEnabled () {
      let clearlyNextFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CLEARLY_NEXT_FEATURE_ID]
      if (clearlyNextFeature && clearlyNextFeature.enabled) {
        return true
      }
      return false
    },
    isExplorePackageEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_FEATURE_ID]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    },
    careerCategories () {
      let categories = this.formattedFacetResults.careerCategory
      if (categories && categories.length > 0) {
        return categories.filter(item => {
          return item.key.toLowerCase().indexOf(this.careerCategorySearch.toLowerCase()) > -1
        })
      }
      return categories
    },
    formattedFacetResults () {
      let formattedFacetResults = {}
      let facetResults = this.careerFacetResults
      let facetFieldMap = this.facetFieldMap
      let isTermFilterSelected = this.isTermFilterSelected
      let isRangeFilterSelected = this.isRangeFilterSelected
      let currencyLabel = this.currencyLabel
      let addCommaInNumber = this.addCommaInNumber
      this.allFacetNames.forEach((facetName) => {
        const fieldName = facetFieldMap[facetName]
        let facetResult = (facetResults && facetResults[facetName]) ? _.cloneDeep(facetResults[facetName]) : {}
        if (facetResult && Object.keys(facetResult).length > 0) {
          let isRangeFacet = Object.keys(facetResult).includes('rangeObj')
          if (isRangeFacet) {
            facetResult = _.cloneDeep(facetResult.rangeObj.buckets)
            facetResult.forEach((range) => {
              if (!range.from) {
                let formatted = addCommaInNumber(range.to)
                range.rangeInterval = '< ' + formatted
                range.label = '< ' + currencyLabel + formatted
              } else if (!range.to) {
                let formatted = addCommaInNumber(range.from)
                range.rangeInterval = '> ' + formatted
                range.label = '>= ' + currencyLabel + formatted
              } else if (range.to && range.from) {
                range.rangeInterval = range.from + '-' + range.to
                range.label = (currencyLabel + addCommaInNumber(range.from)) + '-' + (currencyLabel + addCommaInNumber(range.to))
              }
              range.isSelected = isRangeFilterSelected(range, fieldName)
            })
          } else {
            facetResult = facetResult.termObj.buckets
            facetResult.forEach((termFacet) => {
              termFacet.isSelected = isTermFilterSelected(termFacet, fieldName)
            })
          }
        }
        formattedFacetResults[facetName] = facetResult
      })
      return formattedFacetResults
    },
    formattedResults () {
      let formatted = []
      let results = this.careerSearchResults
      if (!results || results.length <= 0) {
        return formatted
      }
      let isEMSIFeatureEnabled = this.isEMSIFeatureEnabled
      let isBGTFeatureEnabled = this.isBGTFeatureEnabled
      let isLightcastFeatureEnabled = this.isLightcastFeatureEnabled
      let getBookmark = this.getCareerBookmark
      let getThumbnailURI = this.getThumbnailURI
      results.forEach(function (career) {
        let elasticSearchDocument = career.elasticSearchDocument
        career.code = elasticSearchDocument.code
        career.pragyaSoc = elasticSearchDocument.pragyaSoc
        career.medianIncomePerYear = elasticSearchDocument.medianIncomePerYear
        career.growth = elasticSearchDocument.growth
        career.openings = elasticSearchDocument.openings
        career.thumbnailURI = getThumbnailURI(elasticSearchDocument)
        career.bookmark = getBookmark(career)
        if ((isEMSIFeatureEnabled || isBGTFeatureEnabled || isLightcastFeatureEnabled) && career.growth) {
          // EMSI growth values are percentages
          // ONET growth values are blurbs about the career
          career.growth = career.growth + ' %'
        }
        formatted.push(career)
      })
      return formatted
    },
    allFacetNames () {
      return Object.keys(this.facetFieldMap)
    },
    fieldsToFilter () {
      return Object.values(this.facetFieldMap)
    },
    currencyLabel () {
      return '$'
    },
    relevanceSort () {
      return this.sorts[0].clause
    },
    nameSort () {
      return this.sorts[1].clause
    },
    isFacetResultsEmpty () {
      let isEmpty = true
      let formattedFacetResults = this.formattedFacetResults
      this.allFacetNames.forEach(facetName => {
        let facetResult = formattedFacetResults[facetName]
        if (facetName === 'careerIncomeRange' && facetResult.length > 0) {
          facetResult.forEach((range) => {
            isEmpty = isEmpty && range.doc_count === 0
          })
        } else {
          isEmpty = isEmpty && (!facetResult || facetResult.length === 0)
        }
      })
      return isEmpty
    },
    exploreSearchFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_FEATURE_ID
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    isStickyFacetsEnabled () {
      let exploreSearchFlagMap = this.exploreSearchFlagMap
      if (!exploreSearchFlagMap || !exploreSearchFlagMap.enableStickyFacets) {
        return false
      }
      return this.exploreSearchFlagMap.enableStickyFacets.enabled
    },
    showFacetCounts () {
      let exploreSearchFlagMap = this.exploreSearchFlagMap
      if (!exploreSearchFlagMap || !exploreSearchFlagMap.showFacetCounts) {
        return false
      }
      return this.exploreSearchFlagMap.showFacetCounts.enabled
    },
    showCalculateRequiredSkillOnResult () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultCalculateRequiredSkill) {
        return false
      }
      return exploreCareersFlagMap.searchResultCalculateRequiredSkill.enabled
    },
    isStudentLogin () {
      return (localStorage.getItem('userrole') === 'Student')
    }
  },
  watch: {
    showCategoryDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeIncomeRangeDropDown()
        this.closeSortByDropDown()
      } else {
        this.closeCategoryDropDown()
      }
    },
    showIncomeRangeDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeCategoryDropDown()
        this.closeSortByDropDown()
      } else {
        this.closeIncomeRangeDropDown()
      }
    },
    showSortByDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeCategoryDropDown()
        this.closeIncomeRangeDropDown()
      } else {
        this.closeSortByDropDown()
      }
    },
    selectedSort (newSort, oldSort) {
      if ((newSort.length > 0) && (oldSort.length > 0)) {
        this.loadCareerResults()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreCareerResults.vue